/**
 * Created by Kevin Dench on 6/15/2016.
 */
/* @ngInject */
export default function CompareApiService($http, __env) {
    'use strict';

    return {
        /**
         * Execute Comparison
         *
         * Minimum request is one `uniquePn` and `queryParameterValues`, if you do a request of one part
         * and no `queryParameterValues` you will get a bad request error from the server.
         *
         * @param uniquePns - Must be comma-separated list of Part Numbers, no spaces.
         * @param queryParameterValues - Sleuth Result Query Parameter Values.
         * @param success - callback for the success state
         * @param error - callback for the error state
         * @return {*}
         */
        executeComparison: function (uniquePns, queryParameterValues, success, error) {
            return $http.post(
                `${__env.intellidataApiUrl}compare/${uniquePns}/values`,
                queryParameterValues || ''
            ).then(({data}) => {
                success(data);
            })['catch'](error);
        }
    };
}